<template>
  <div class="clock">
    <div class="clock__column">
      <span class="clock__day">
        {{currentDate}}
      </span>
    </div>
    <div class="clock__column">
      <span class="clock__time">
        {{formatedTime}}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent, onMounted, Ref, ref,
} from 'vue';
import { format } from 'date-fns';
import { pl } from 'date-fns/locale';
import moment from 'moment';

const Clock: object = defineComponent({
  name: 'Clock',
  setup() {
    const currentTime: Ref<Date> = ref(new Date());
    const formatedTime: Ref<string> = computed(() => format(currentTime.value, 'HH:mm', { locale: pl }));
    const currentDate: Ref<string> = computed(() => moment().format("DD.MM.YYYY"));

    onMounted(() => {
      currentTime.value = new Date();
      const offset = 1000 - currentTime.value.getMilliseconds();
      setTimeout(() => {
        setInterval(() => {
          currentTime.value = new Date();
        }, 1000);
      }, offset);
    });

    return {
      currentTime,
      formatedTime,
      currentDate,
    };
  },
});
export default Clock;
</script>

<style scoped lang="scss">
  .clock{
    display: inline-flex;
    &__column{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      padding: 4px 0;
      font-size: rem(12px);
      margin-right: rem(8px);

      @include width-until($mobile) {
        font-size: rem(18px);
        padding: 0;
      }
    }
    &__time{
      font-size: rem(30px);
      line-height: 0.875rem;
      font-weight: 700;

      @include width-until($mobile) {
        font-size: rem(18px);
      }
    }
    &__day, &__weekday{
      font-size: rem(16px);
      font-weight: 700;
      white-space: nowrap;
      line-height: 1.35;

      @include width-until($mobile) {
        font-size: rem(12px);
      }
    }
  }
</style>
